// 🔒
export const testimonials = [
  {
    id: 1,
    name: "Tanja",
    text: "An excellent program — I got noticeably stronger and found it so much easier to stay consistent.",
    stars: 5
  },
  {
    id: 2,
    name: "Maj",
   text: "A really solid program. The workouts are clear, effective, and genuinely keep you motivated.",
    stars: 4
  },
  {
    id: 3,
    name: "Ana",
    text: "Brilliantly guided workouts with a great sense of progress that builds week after week.",
    stars: 5
  },
  {
    id: 4,
    name: "Sara",
    text: "The app is clean and easy to use, and the workouts are varied enough to never get boring.",
    stars: 5
  },
  {
    id: 5,
    name: "Niko",
    text: "I love how structured and easy the programs are — always simple and clear to follow along.",
    stars: 4
  },
  {
    id: 6,
    name: "Ema",
    text: "For the first time I feel like I'm training smart and with purpose, not just randomly.",
    stars: 5
  },
  {
    id: 7,
    name: "Klara",
    text: "A beautifully designed experience. Workouts are clear, practical, and just intense enough.",
    stars: 5
  },
  {
    id: 8,
    name: "Marko",
    text: "Great for beginners and for anyone who already trains but is looking for a better system.",
    stars: 4
  },
  {
    id: 9,
    name: "Petra",
    text: "A perfect blend of motivation, structure, and a real sense of progress after every week.",
    stars: 5
  }
];
// 🔒